export default "__VITE_ASSET__BVgkMGbI__"